import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import API from '../../../create/api';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { Box, LinearProgress, Pagination, TextField, Switch } from '@mui/material';
import _, { debounce } from 'lodash';
import querystring from 'querystring';
import axios from 'axios';
import { useStore } from 'react-redux';

export default function SpanningTable() {
  const store = useStore();
  const [rows, setRows] = useState([]);
  const [get_page_no, set_page_no] = useState(1);
  const [get_total_rider_count, set_total_rider_count] = useState(0);
  const [loading, setLoading] = useState(false);

  const initialLimit = localStorage.getItem('riderLimit') ? JSON.parse(localStorage.getItem('riderLimit') ?? '') : 500;
  const initialSortType = localStorage.getItem('riderArea')
    ? JSON.parse(localStorage.getItem('riderSort') ?? '')
    : 'id:ASC';

  const [limit, setLimit] = React.useState(initialLimit);
  const [sortBy, setSortBy] = useState(initialSortType);
  const [search, setSearch] = useState('');

  async function fetchAPI() {
    setLoading(true);
    const getArea = {
      _start: (get_page_no - 1) * limit,
      _limit: limit,
      _sort: sortBy,
      _q: search,
    };
    const param = querystring.encode(_.pickBy(getArea, _.identity));
    const [riders, count]: any[] = await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/riders?${param}`),
      API.count(`${process.env.REACT_APP_API_SERVER}/riders/count?${param}`),
    ]);
    setRows(riders);
    set_total_rider_count(count);
    setLoading(false);
  }

  useEffect(() => {
    fetchAPI();
    // eslint-disable-next-line
  }, [get_page_no, limit, sortBy, search]);

  const history = useHistory();

  const [deleteID, setDeleteID] = useState(undefined);
  const [open, setOpen] = React.useState(false);

  const handleOpen = (id: any) => {
    setDeleteID(id);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteID(undefined);
    setOpen(false);
  };

  // rest api
  async function deleteRider() {
    if (deleteID) {
      await API.destroy(`${process.env.REACT_APP_API_SERVER}/riders`, deleteID)
        .then((res) => {
          fetchAPI();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          handleClose();
        });
    }
  }

  const handleSearchField = debounce((searchValue: string) => {
    setLoading(true);
    setSearch(searchValue);
    setLoading(false);
  }, 3000);

  return (
    <TableContainer component={Paper} className="p-4">
      {loading && <LinearProgress />}
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className="flex items-center justify-center"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="bg-white border-2 border-black shadow-lg p-6">
          <h1 id="spring-modal-title" className="text-lg font-bold">
            Delete
          </h1>
          <p id="spring-modal-description">
            Do you want to delete ID {deleteID}
            <br />
            <Button color="secondary" onClick={deleteRider}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <Table className="min-w-full" aria-label="a spanning dense table" padding="checkbox">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} align="left">
              <Box className="flex">
                <span className="px-2">Search</span>
                <TextField
                  className="ml-2"
                  fullWidth
                  variant="standard"
                  onChange={(e) => {
                    handleSearchField(e?.target.value);
                  }}
                />
              </Box>
            </TableCell>
            <TableCell colSpan={12} align="right">
              <div className="flex justify-end p-1">
                <Pagination
                  color="primary"
                  count={Math.ceil(get_total_rider_count / limit)}
                  variant="outlined"
                  shape="rounded"
                  page={get_page_no}
                  onChange={(e, page) => {
                    set_page_no(page);
                  }}
                />
                <Box sx={{ px: 2 }}>
                  <label htmlFor="limit">Set limit:</label>
                  <select
                    onChange={(e: any) => {
                      setLimit(e.target.value);
                      localStorage.setItem('riderLimit', JSON.stringify(e.target.value));
                    }}
                    className="cursor-pointer p-1"
                    defaultValue={limit}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                  </select>
                </Box>
                <Box>
                  <label htmlFor="sort">Sort by:</label>
                  <select
                    value={sortBy}
                    onChange={(e: any) => {
                      setSortBy(e.target.value);
                      localStorage.setItem('riderSort', JSON.stringify(e.target.value));
                    }}
                    className="cursor-pointer p-1"
                  >
                    <option value={'id:ASC'}>Old to New</option>
                    <option value={'id:DESC'}>New to Old</option>
                    <option value={'name:ASC'}>A to Z</option>
                    <option value={'updated_at:DESC'}>Last Update</option>
                  </select>
                </Box>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell align="left">Name</TableCell>
            <TableCell align="left">Number</TableCell>
            <TableCell align="left" className="pl-3">
              Status
            </TableCell>
            <TableCell align="center">Edit</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">{row.number}</TableCell>
              <TableCell align="left">
                <Switch
                  {...{ inputProps: { 'aria-label': 'Switch demo' } }}
                  checked={row?.user?.confirmed}
                  onChange={async (e) => {
                    await axios
                      .put(
                        `${process.env.REACT_APP_API_SERVER}/riders/verify/${row.id}`,
                        { confirmed: e.target.checked, user: row?.user?.id },
                        {
                          headers: {
                            Authorization: `Bearer ${store.getState().auth.jwt}`,
                          },
                        },
                      )
                      .then((response) => {
                        setTimeout(() => {
                          fetchAPI();
                        }, 1000);
                      });
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <IconButton
                  color="primary"
                  onClick={() => {
                    history.push(`/dashboard/rider/edit/${row.id}`);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center">
                <IconButton
                  color="secondary"
                  onClick={() => {
                    handleOpen(row.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
